import React from 'react';
import { Button, Table, Header, Segment, Icon } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { Redirect } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import TableRow from '../../Admin/CreateCourse/TableRow';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const registration = [
    {
        key: 1,
        value: 1,
        text: 'Određeni broj dana prije svakog ispita'
    },
    {
        key: 2,
        value: 2,
        text: 'Određeni datum za sve ispite'
    }
];


export default class EditExamTerm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newName: '',
            newStartDate: moment(this.props.location.state.exam.startDate).format(),
            newEndDate: moment(this.props.location.state.exam.endDate).format(),
            newComment: '',
            newRegistrationOpeningDays: null,
            newOneExamRestriction: '',
            newGradStudentExamRestriction: '',
            newGradAgainStudentExamRestriction: '',
            newRegistrationOpeningDate: this.props.location.state.registrationOpeningDate ? moment(this.props.location.state.registrationOpeningDate).format() : null,
            newRegistrationClosing: '',
            registrationType: this.props.location.state.exam.registrationOpeningDate ? 2 : this.props.location.state.exam.registrationOpeningDays ? 1 : null,

            edit: false,
            updated: null,
            noEdited: false
        };

        this.onChange = this.onChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.editExamTerm = this.editExamTerm.bind(this);
    }

    handleDateChange(name, date) {
        this.setState({ edit: true });
        if (name === 'startDate') { this.setState({ newStartDate: date }); }
        if (name === 'endDate') { this.setState({ newEndDate: date }); }
        if (name === 'registrationOpeningDate') { this.setState({ newRegistrationOpeningDate: date }); }
    }
    handleInputChange(event, { name, value }) {
        this.setState({ [name]: value });
    }

    editExamTerm() {
        if (this.state.newRegistrationClosing && this.state.newRegistrationOpeningDays && this.state.newRegistrationOpeningDays < this.state.newRegistrationClosing) {
            toast('Broj dana prije ispita od kada počinje prijava ispita mora biti veći od broja dana prije ispita do kada traje prijava ispita.');
            return;
        } else if (this.state.newRegistrationOpeningDays && this.props.location.state.exam.registrationClosing && this.props.location.state.exam.registrationClosing > this.state.newRegistrationOpeningDays) {
            toast('Broj dana prije ispita od kada počinje prijava ispita mora biti veći od broja dana prije ispita do kada traje prijava ispita.');
            return;
        }

        if (this.state.newRegistrationOpeningDate > this.props.location.state.exam.startDate) {
            toast('Datum početka prijave ispita mora biti prije datuma početka ispitnog roka!');
            return;
        }

        let newExamTerm = { optLock: this.props.location.state.exam.optLock, id: this.props.location.state.exam.id };

        if (this.state.registrationType === 1 && this.state.newRegistrationOpeningDays !== null) {
            newExamTerm = { ...newExamTerm, registrationOpeningDays: this.state.newRegistrationOpeningDays };
        }

        if (this.state.registrationType === 2 && this.state.newRegistrationOpeningDate !== null) {
            newExamTerm = { ...newExamTerm, registrationOpeningDate: this.state.newRegistrationOpeningDate };
        }

        if (this.state.newName) newExamTerm = { ...newExamTerm, name: this.state.newName };
        if (this.state.newStartDate) newExamTerm = { ...newExamTerm, startDate: moment(this.state.newStartDate).format() };
        if (this.state.newEndDate) newExamTerm = { ...newExamTerm, endDate: moment(this.state.newEndDate).format() };
        if (this.state.newComment) newExamTerm = { ...newExamTerm, comment: this.state.newComment };
        // if (this.state.newRegistrationOpeningDays) newExamTerm = { ...newExamTerm, registrationOpeningDays: this.state.newRegistrationOpeningDays };
        if (this.state.newRegistrationClosing) newExamTerm = { ...newExamTerm, registrationClosing: this.state.newRegistrationClosing };
        if (this.state.newOneExamRestriction !== '') newExamTerm = { ...newExamTerm, oneExamRestriction: this.state.newOneExamRestriction };

        if (this.state.newGradStudentExamRestriction !== '') {
            newExamTerm = { ...newExamTerm, gradStudentExamRestriction: this.state.newGradStudentExamRestriction };
        }

        if (this.state.newGradAgainStudentExamRestriction !== '') {
            newExamTerm = { ...newExamTerm, gradAgainStudentExamRestriction: this.state.newGradAgainStudentExamRestriction };
        }

        axios.put('/exams/update-term', { ...newExamTerm })
            .then(res => {
                this.setState({ updated: true });
            })
            .catch(err => {
                this.setState({ updated: false });
            });
    }

    onChange(keyName, value) {
        if (keyName === 'name') { this.setState({ newName: value }); }

        if (keyName === 'comment') { this.setState({ newComment: value }); }

        if (keyName === 'registrationOpeningDays') { this.setState({ newRegistrationOpeningDays: value }); }

        if (keyName === 'registrationClosing') { this.setState({ newRegistrationClosing: value }); }
    }


    render() {
        const { exam } = this.props.location.state;

        if (this.state.updated === true && this.state.noEdited === false) {
            return <Redirect push to={{ pathname: '/ispitni-rokovi', state: { updated: true } }} />;
        } else if (this.state.updated === false && this.state.noEdited === false) {
            return <Redirect push to={{ pathname: '/ispitni-rokovi', state: { updated: false } }} />;
        } else if (this.state.noEdited === true) {
            return <Redirect push to={{ pathname: '/ispitni-rokovi' }} />;
        }

        return (
            <div>
                <Header as="h1">{exam.name}</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        {/* <Header as="h3"> */}
                        {/*    Izmjena ispitnog roka */}
                        {/*    <Icon link circular basic floated="right" name="chevron up" /> */}
                        {/*    <Button */}
                        {/*        basic="true" */}
                        {/*        color="blue" */}
                        {/*        onClick={() => { window.history.go(-1); }} */}
                        {/*    > */}
                        {/*        Nazad */}
                        {/*    </Button> */}
                        {/* </Header> */}
                        {/* <Button circular color='facebook' icon='facebook' /> */}

                    </Segment>
                    <Segment clearing >

                        <Table celled unstackable compact >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="left" style={{ fontSize: '17px' }}>
                                        Trenutni podaci
                                    </Table.HeaderCell>
                                    <Table.HeaderCell style={{ fontSize: '17px' }}>
                                        Novi podaci
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <TableRow
                                    name="Naziv ispitnog roka"
                                    keyName="name"
                                    value={exam.name}
                                    onChange={this.onChange}
                                    defValue={exam.name}
                                />
                                <TableRow
                                    name="Datum početka"
                                    keyName="startDate"
                                    value={moment(exam.startDate).format('D. M. YYYY.')}
                                    handleDateChange={this.handleDateChange.bind(null, 'startDate')}
                                    defValue={exam.startDate}
                                />
                                <TableRow
                                    name="Datum kraja"
                                    keyName="endDate"
                                    value={moment(exam.endDate).format('D. M. YYYY.')}
                                    handleDateChange={this.handleDateChange.bind(null, 'endDate')}
                                    defValue={exam.endDate}
                                />

                                <TableRow
                                    name="Početak prijave ispita"
                                    keyName="registrationType"
                                    value={exam.registrationOpeningDate ? 'Određeni datum za sve ispite' : exam.registrationOpeningDays ? 'Određeni broj dana prije svakog ispita' : null}
                                    onChange={this.handleInputChange}
                                    defValue={exam.registrationOpeningDate ? 2 : exam.registrationOpeningDays ? 1 : null}
                                    options={registration}
                                />
                                {this.state.registrationType === 1 ?
                                    <TableRow
                                        name="Broj dana prije ispita od kada počinje prijava ispita"
                                        keyName="registrationOpeningDays"
                                        value={exam.registrationOpeningDays ? exam.registrationOpeningDays : null}
                                        onChange={this.onChange}
                                        defValue={exam.registrationOpeningDays ? exam.registrationOpeningDays : null}
                                    /> :
                                    this.state.registrationType === 2 ?
                                        <TableRow
                                            name="Datum od kojeg počinje prijava ispita"
                                            keyName="registrationOpeningDate"
                                            value={exam.registrationOpeningDate ? moment(exam.registrationOpeningDate).format('D. M. YYYY.') : null}
                                            handleDateChange={this.handleDateChange.bind(null, 'registrationOpeningDate')}
                                            defValue={exam.registrationOpeningDate ? exam.registrationOpeningDate : new Date()}
                                        /> : null
                                }
                                <TableRow
                                    name="Broj dana prije ispita do kada traje prijava ispita"
                                    keyName="registrationClosing"
                                    value={exam.registrationClosing}
                                    onChange={this.onChange}
                                    defValue={exam.registrationClosing}
                                />
                                <TableRow
                                    type="checkbox"
                                    label="ograničenje na prijavu samo jednog ispita"
                                    name="Ograničenje na prijavu jednog ispita"
                                    keyName="oneExamRestriction"
                                    value={exam.oneExamRestriction ? 'uključeno' : 'isključeno'}
                                    checked={this.state.newOneExamRestriction === '' ? exam.oneExamRestriction : !!this.state.newOneExamRestriction}
                                    onChange={() => { this.setState({ newOneExamRestriction: !this.state.newOneExamRestriction }); }}
                                    defValue={exam.oneExamRestriction}
                                />
                                <TableRow
                                    type="checkbox"
                                    label="ograničenje da rok vide samo apsolventi"
                                    name="Ograničenje da rok vide samo apsolventi"
                                    keyName="gradStudentExamRestriction"
                                    value={exam.gradStudentExamRestriction ? 'uključeno' : 'isključeno'}
                                    checked={this.state.newGradStudentExamRestriction === '' ? exam.gradStudentExamRestriction : !!this.state.newGradStudentExamRestriction}
                                    onChange={() => { this.setState({ newGradStudentExamRestriction: !this.state.newGradStudentExamRestriction }); }}
                                    defValue={exam.gradStudentExamRestriction}
                                />

                                <TableRow
                                    type="checkbox"
                                    label="ograničenje da rok vide samo apsolventi ponovci"
                                    name="Ograničenje da rok vide samo apsolventi ponovci"
                                    keyName="gradAgainStudentExamRestriction"
                                    value={exam.gradAgainStudentExamRestriction ? 'uključeno' : 'isključeno'}
                                    checked={this.state.newGradAgainStudentExamRestriction === '' ? exam.gradAgainStudentExamRestriction : !!this.state.newGradAgainStudentExamRestriction}
                                    onChange={() => { this.setState({ newGradAgainStudentExamRestriction: !this.state.newGradAgainStudentExamRestriction }); }}
                                    defValue={exam.gradAgainStudentExamRestriction}
                                />

                                <TableRow
                                    name="Napomena"
                                    keyName="comment"
                                    value={exam.comment}
                                    onChange={this.onChange}
                                    defValue={exam.comment}
                                />
                            </Table.Body>
                        </Table>
                        <Button
                            floated="right"
                            color="blue"
                            basic="true"
                            onClick={() => { this.setState({ noEdited: true }); }}
                        >
                            Odustani
                        </Button>
                        <Button
                            floated="right"
                            color="blue"
                            onClick={this.editExamTerm}
                        >
                            Sačuvaj izmjene
                        </Button>
                    </Segment>
                    <ToastContainer hideProgressBar />

                </Segment.Group >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/EditExamTerm.js